import { Box, Grid, Typography, Button } from '@mui/material';
import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom/dist';
import callfooter from '../../assets/HomePageImages/callfooter.svg';
import messagefooter from '../../assets/HomePageImages/messagefooter.svg';
import IRTA_LOGO from '../../assets/HomePageImages/IRTA_LOGO.png';
import phone from '../../assets/HeaderIcon/phone.svg';
import messageicon from '../../assets/HeaderIcon/messageicon.svg';
import insta from '../../assets/marketplaceicons/footericons/instagram.svg';
import fbicon from '../../assets/marketplaceicons/footericons/Facebook.svg';
import linkdinicon from '../../assets/marketplaceicons/footericons/linkedin.svg';
import twiticon from '../../assets/marketplaceicons/footericons/twitter.svg';
import youtubeicon from '../../assets/marketplaceicons/footericons/yt.svg';
import NDA from '../../assets/HomePageImages/NDA.png';
import pdfimgnew from '../../assets/HomePageImages/pdfimgnew.svg';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import NewTwitter from '../../assets/twitterVector.svg';
import YouTubeIcon from '@mui/icons-material/YouTube';
import fb from '../../assets/HomePageImages/fb.svg';
import { keyframes } from '@emotion/react';

const Footer = (props) => {
  const navigate = useNavigate();

  const addressLabel = 'Address';
  const addressText = 'Unit Part B on 3rd floor, VKG Corporate Centre, Andheri Kurla Road, opp. IRA Hotel, Andheri East, Mumbai - 400 059.';
  const contactLabel = 'Contact Us';
  const contactPhone = '+91 8828326776';
  const contactPhone2 = '+91 9136436776';
  const contactEmail = 'business@bxiworld.com';
  const whatsappLink = 'https://api.whatsapp.com/send/?phone=9136436776&text&type=phone_number&app_absent=0';
  const copyrightText = '© {year} BXI World LLP. All Rights Reserved.'.replace('{year}', new Date().getFullYear());
  const footerLogo = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/category/Assets/BXI_WHITE_LOGO.svg';

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const Location = useLocation();
  const buttonAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;
  async function openEmail(e) {
    window.location.href = `mailto:${contactEmail}`;
  }

  return (
    <>
      <Box
        sx={{
          display: {
            xl: 'block',
            lg: 'block',
            md: 'block',
            sm: 'none',
            xs: 'none',
          },
        }}
      >
        <Grid
          container
          sx={{
            background: 'rgba(255, 255, 255, 1)',
            p: 1,
          }}
        >
          <Grid
            item
            xl={2}
            lg={3}
            md={12}
            sm={12}
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: {
                  xl: 'flex-start',
                  lg: 'flex-start',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
                width: '90%',
                mx: 'auto',
              }}
            >
              <img src={footerLogo} width={50} height={45} alt="BXI Logo" title='BXI Logo' />
            </Box>
            <Box>
              <Typography
                sx={{
                  ...FooterText,
                  width: '90%',
                  mx: 'auto',
                  lineHeight: '50px',
                }}
              >
                {addressLabel}
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  width: '90%',
                  mx: 'auto',
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                }}
              >
                {addressText}
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  ...FooterText,
                  width: '90%',
                  mx: 'auto',
                  lineHeight: '50px',
                }}
              >
                {contactLabel}
              </Typography>
              <a
                href={whatsappLink}
                target="_blank"
                alt="wtsp"
                title='whatsapp message'
                style={{ textDecoration: 'none' }} rel="noreferrer"
              >
                <Box
                  sx={{
                    display: 'flex',
                    width: '95%',
                    mx: 'auto',
                    gap: '10px',
                    justifyContent: {
                      xl: 'flex-start',
                      lg: 'flex-start',
                      md: 'center',
                      sm: 'center',
                      xs: 'center',
                    },
                  }}
                >
                  <img
                    src={phone}
                    alt="wtsp"
                    title='wtsp Logo'
                    width={15}
                    height={15}
                    style={{
                      width: '15px',
                      height: 'auto',
                      marginLeft: '07px',
                    }}
                  />

                  <Typography sx={{ ...textDesign, mt: 0.5 }}>
                    {contactPhone} || {contactPhone2}
                  </Typography>
                </Box>
              </a>
              <Box
                onClick={openEmail}
                sx={{
                  display: 'flex',
                  width: '95%',
                  mx: 'auto',
                  gap: '10px',
                  cursor: 'pointer',
                  mt: 0,
                  justifyContent: {
                    xl: 'flex-start',
                    lg: 'flex-start',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                }}
              >
                <img
                  src={messageicon}
                  alt="message"
                  title='message icon'
                  width={17}
                  height={17}
                  style={{ width: '17px', height: 'auto', marginLeft: '07px' }}
                />
                <Typography sx={{ ...textDesign, mt: 0.4 }}>
                  {contactEmail}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xl={2}
            lg={2}
            md={12}
            sm={12}
            xs={12}
            sx={{ pt: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 } }}
          >
            <Box sx={{ mt: { xl: 6, lg: 6, md: 1, sm: 1, xs: 1 } }}>
              <Typography
                sx={{
                  ...FooterText,
                  mt: {
                    xl: -5,
                    lg: -5,
                    md: 0,
                    sm: 0,
                    xs: 0,
                  },
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  lineHeight: '20px',
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                }}
              >
                Helpful Links
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  lineHeight: '25px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate('/about');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                About Us
              </Typography>
              <Link
                to="/blog"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: {
                      xl: 'left',
                      lg: 'left',
                      md: 'center',
                      sm: 'center',
                      xs: 'center',
                    },
                    width: {
                      xl: '60%',
                      lg: '60%',
                      md: '60%',
                      sm: '100%',
                      xs: '100%',
                    },
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Blog
                </Typography>
              </Link>
              <Link
                to="/termsconditions"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: {
                      xl: 'left',
                      lg: 'left',
                      md: 'center',
                      sm: 'center',
                      xs: 'center',
                    },
                    width: {
                      xl: '60%',
                      lg: '60%',
                      md: '60%',
                      sm: '100%',
                      xs: '100%',
                    },
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Terms & Conditions
                </Typography>
              </Link>
              <Link
                to="/privacypolicy"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: {
                      xl: 'left',
                      lg: 'left',
                      md: 'center',
                      sm: 'center',
                      xs: 'center',
                    },
                    width: {
                      xl: '60%',
                      lg: '60%',
                      md: '60%',
                      sm: '100%',
                      xs: '100%',
                    },
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Privacy Policy
                </Typography>
              </Link>
              <Link
                to="/legalpolicy"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: {
                      xl: 'left',
                      lg: 'left',
                      md: 'center',
                      sm: 'center',
                      xs: 'center',
                    },
                    width: {
                      xl: '60%',
                      lg: '60%',
                      md: '60%',
                      sm: '100%',
                      xs: '100%',
                    },
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Legal policy
                </Typography>
              </Link>
              <Link
                to="/contact-us"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: {
                      xl: 'left',
                      lg: 'left',
                      md: 'center',
                      sm: 'center',
                      xs: 'center',
                    },
                    width: {
                      xl: '60%',
                      lg: '60%',
                      md: '60%',
                      sm: '100%',
                      xs: '100%',
                    },
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Contact us
                </Typography>
              </Link>
            </Box>
          </Grid>
          <Grid
            item
            xl={2}
            lg={2}
            md={12}
            sm={12}
            xs={12}
            sx={{ pt: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 } }}
          >
            <Box sx={{ mt: { xl: 6, lg: 6, md: 1, sm: 1, xs: 1 } }}>
              <Typography
                sx={{
                  ...FooterText,
                  mt: {
                    xl: -5,
                    lg: -5,
                    md: 0,
                    sm: 0,
                    xs: 0,
                  },
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  lineHeight: '20px',
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                }}
              >
                BXI World LLP
              </Typography>
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  fontSize: '10.5px',
                  fontFamily: 'Poppins',
                  fontWeight: 300,
                  color: 'rgba(18, 18, 18, 1)',
                }}
              >
                Registered Name
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  lineHeight: '25px',
                }}
              >
                PAN: AAXFB2929C
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  lineHeight: '25px',
                }}
              >
                GST: 27AAXFB2929C1ZA
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xl={2}
            lg={2}
            md={12}
            sm={12}
            xs={12}
            sx={{ pt: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 } }}
          >
          </Grid>
          <Grid
            item
            xl={4}
            lg={3}
            md={12}
            sm={12}
            xs={12}
            sx={{ pt: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }, mt: 0 }} // Set mt to 0 to remove space above
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: {
                  xl: 'row',
                  lg: 'row',
                  md: 'row',
                  sm: 'column',
                  xs: 'column',
                },
                justifyContent: {
                  xl: 'flex-end',
                  lg: 'flex-end',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
                alignItems: 'center',
                gap: { xl: 4, lg: 4, md: 3, sm: 2, xs: 2 },
                pr: { xl: 6, lg: 6, md: 0, sm: 0, xs: 0 },
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <a
                  href="https://www.irta.com/member-directory/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '60.88px',
                  }}
                >
                  <img
                    src={IRTA_LOGO}
                    width={151}
                    height={51}
                    style={{
                      width: '150.68px',
                      maxWidth: '100%',
                      height: '50.88px',
                      textAlign: 'center',
                    }}
                    alt="IRTA Logo"
                    title='IRTA Logo'
                  />
                </a>
                <Typography
                  sx={{
                    ...FooterText,
                    lineHeight: '20px',
                    mt: 2,
                  }}
                >
                  Global Barter Council
                </Typography>
              </Box>
              <Box
                sx={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <a
                  href="https://www.startupindia.gov.in/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '60.88px',
                  }}
                >
                  <img
                    src={'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/category/landing+page/Startup+India+-+Logo+%282%29.svg'}
                    width={161}
                    height={61}
                    style={{
                      width: '160.68px',
                      maxWidth: '100%',
                      height: '60.88px',
                      textAlign: 'center',
                    }}
                    alt="DPIIT Logo"
                    title='DPIIT Logo'
                  />
                </a>
                <Typography
                  sx={{
                    ...FooterText,
                    lineHeight: '20px',
                    mt: 2,
                  }}
                >
                  Recognized by DPIIT
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Box
            sx={{
              borderBottom: '1px solid rgba(214, 214, 214, 1)',
              width: '98%',
              mx: 'auto',
              mt: 2,
            }}
          ></Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: {
                xl: 'row',
                lg: 'row',
                md: 'row',
                sm: 'column',
                xs: 'column',
              },
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: {
                  xl: 'flex-end',
                  lg: 'flex-end',
                  md: 'flex-end',
                  sm: 'center',
                  xs: 'center',
                },
                width: {
                  xl: '80%',
                  lg: '80%',
                  md: '80%',
                  sm: '100%',
                  xs: '100%',
                },
                mt: 1,
                gap: '10px',
                marginLeft: {
                  xl: '200px',
                  lg: '200px',
                  md: '200px',
                  sm: '0px',
                  xs: '0px',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: '10px',
                  justifyContent: 'flex-start',
                }}
              >
                <Box
                  sx={{
                    ...socialIcons,
                  }}
                >
                  <a
                    href="https://instagram.com/bxi.world?igshid=MzRlODBiNWFlZA== "
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={insta} alt="insta" width={24} height={24} style={{ height: '24px', width: '24px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href="https://www.facebook.com/bxi.world?mibextid=ZbWKwL "
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={fbicon} alt="insta" width={22} height={22} style={{ height: '22px', width: '22px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href=" https://www.linkedin.com/company/barter-exchange-of-india/"
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }}
                  >
                    <img src={linkdinicon} alt="insta" width={22} height={22} style={{ height: '22px', width: '22px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href="https://twitter.com/bximarketplace?s=20"
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={twiticon} alt="twiticon" width={19} height={19} style={{ height: '19px', width: 'auto' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href="https://www.youtube.com/@bxiworld"
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={youtubeicon} alt="youtubeicon" width={26} height={26} style={{ height: 'auto', width: '26px' }} />
                  </a>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: {
                  xl: 'flex-end',
                  lg: 'flex-end',
                  md: 'flex-end',
                  sm: 'center',
                  xs: 'center',
                },
                width: {
                  xl: '80%',
                  lg: '80%',
                  md: '80%',
                  sm: '100%',
                  xs: '100%',
                },
              }}
            >
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'right',
                    lg: 'right',
                    md: 'right',
                    sm: 'center',
                    xs: 'center',
                  },
                  fontSize: {
                    xl: '14px',
                    lg: '14px',
                    md: '14px',
                    sm: '12px',
                    xs: '12px',
                  },
                  mt: 1.3,
                }}
              >
                {copyrightText}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Box>
      <Box
        sx={{
          display: {
            xl: 'none',
            lg: 'none',
            md: 'none',
            sm: 'block',
            xs: 'block',
          },
        }}
      >
        <Grid
          container
          sx={{
            background: 'rgba(255, 255, 255, 1)',
            p: 1,
          }}
        >
          <Grid
            item
            sm={6}
            xs={6}
            sx={{ pt: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 } }}
          >
            <Box sx={{ mt: { xl: 6, lg: 6, md: 1, sm: 1, xs: 1 } }}>
              <Typography
                sx={{
                  ...FooterText,
                  mt: {
                    xl: -5,
                    lg: -5,
                    md: 0,
                    sm: 0,
                    xs: 0,
                  },
                  textAlign: 'left',
                  lineHeight: '20px',
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '80%',
                    xs: '80%',
                  },
                  mx: 'auto',
                }}
              >
                Helpful Links
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: 'left',
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '80%',
                    xs: '80%',
                  },
                  mx: 'auto',
                  lineHeight: '25px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate('/about');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                About Us
              </Typography>
              <Link
                to="/blog"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: 'left',
                    width: '80%',
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Blog
                </Typography>
              </Link>
              <Link
                to="/termsconditions"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: 'left',
                    width: '80%',
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Terms & Conditions
                </Typography>
              </Link>
              <Link
                to="/privacypolicy"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: 'left',
                    width: '80%',
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Privacy Policy
                </Typography>
              </Link>
              <Link
                to="/legalpolicy"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: 'left',
                    width: '80%',
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Legal policy
                </Typography>
              </Link>
              <Link
                to="/contact-us"
                style={{ textDecoration: 'none' }}
                onClick={scrollToTop}
              >
                <Typography
                  sx={{
                    ...textDesign,
                    textAlign: 'left',
                    width: '80%',
                    mx: 'auto',
                    lineHeight: '25px',
                  }}
                >
                  Contact us
                </Typography>
              </Link>
            </Box>
          </Grid>
          <Grid
            item
            sm={6}
            xs={6}
            sx={{ pt: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 } }}
          >
            <Box sx={{ mt: { xl: 6, lg: 6, md: 1, sm: 1, xs: 1 } }}>
              <Typography
                sx={{
                  ...FooterText,
                  mt: {
                    xl: -5,
                    lg: -5,
                    md: 0,
                    sm: 0,
                    xs: 0,
                  },
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  lineHeight: '20px',
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                }}
              >
                BXI World LLP
              </Typography>
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  fontSize: '10.5px',
                  fontFamily: 'Poppins',
                  fontWeight: 300,
                  color: 'rgba(18, 18, 18, 1)',
                }}
              >
                Registered Name
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  lineHeight: '25px',
                }}
              >
                PAN: AAXFB2929C
              </Typography>
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'left',
                    lg: 'left',
                    md: 'center',
                    sm: 'center',
                    xs: 'center',
                  },
                  width: {
                    xl: '60%',
                    lg: '60%',
                    md: '60%',
                    sm: '100%',
                    xs: '100%',
                  },
                  mx: 'auto',
                  lineHeight: '25px',
                }}
              >
                GST: 27AAXFB2929C1ZA
              </Typography>
              <Box
                sx={{
                  mx: 'auto',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }}
              >
                <a
                  href="https://www.irta.com/member-directory/"
                  target="_blank" rel="noreferrer"
                >
                  <img
                    src={IRTA_LOGO}
                    width={111}
                    height={41}
                    style={{
                      width: '110.68px',
                      height: '40.88px',
                      textAlign: 'center',
                    }}
                    alt="IRTA Logo"
                    title='IRTA Logo'
                  />
                </a>
                <Typography
                  sx={{
                    ...FooterText,
                    lineHeight: '20px',
                    fontSize: {
                      xl: '18px',
                      lg: '18px',
                      md: '18px',
                      sm: '12px',
                      xs: '12px',
                    },
                    mt: 1,
                    ml: 1,
                  }}
                >
                  Global Barter Council
                </Typography>
              </Box>
              <Box
                sx={{
                  mx: 'auto',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  mt: 2,
                }}
              >
                <a
                  href="https://www.startupindia.gov.in/"
                  target="_blank" rel="noreferrer"
                >
                  <img
                    src={'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/category/landing+page/Startup+India+-+Logo+%282%29.svg'}
                    width={111}
                    height={41}
                    style={{
                      width: '110.68px',
                      height: '40.88px',
                      textAlign: 'center',
                    }}
                    alt="DPIIT Logo"
                    title='DPIIT Logo'
                  />
                </a>
                <Typography
                  sx={{
                    ...FooterText,
                    lineHeight: '20px',
                    fontSize: {
                      xl: '18px',
                      lg: '18px',
                      md: '18px',
                      sm: '12px',
                      xs: '12px',
                    },
                    mt: 1,
                    ml: 1,
                  }}
                >
                  Recognized by DPIIT
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Box
            sx={{
              borderBottom: '1px solid rgba(214, 214, 214, 1)',
              width: '98%',
              mx: 'auto',
              mt: 2,
            }}
          ></Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: {
                xl: 'row',
                lg: 'row',
                md: 'row',
                sm: 'column',
                xs: 'column',
              },
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: {
                  xl: 'flex-end',
                  lg: 'flex-end',
                  md: 'flex-end',
                  sm: 'center',
                  xs: 'center',
                },
                width: {
                  xl: '80%',
                  lg: '80%',
                  md: '80%',
                  sm: '100%',
                  xs: '100%',
                },
                mt: 1,
                gap: '10px',
                marginLeft: {
                  xl: '200px',
                  lg: '200px',
                  md: '200px',
                  sm: '0px',
                  xs: '0px',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: '10px',
                  justifyContent: 'flex-start',
                }}
              >
                <Box
                  sx={{
                    ...socialIcons,
                  }}
                >
                  <a
                    href="https://instagram.com/bxi.world?igshid=MzRlODBiNWFlZA== "
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={insta} alt="insta" width={18} height={18} style={{ height: '18px', width: '18px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href="https://www.facebook.com/bxi.world?mibextid=ZbWKwL "
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={fbicon} alt="insta" width={17} height={17} style={{ height: '17px', width: '17px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href=" https://www.linkedin.com/company/barter-exchange-of-india/"
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }}
                  >
                    <img src={linkdinicon} alt="insta" width={17} height={17} style={{ height: '17px', width: '17px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href="https://twitter.com/bximarketplace?s=20"
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={twiticon} alt="twiticon" width={17} height={17} style={{ height: '17px', width: '17px' }} />
                  </a>
                </Box>
                <Box sx={socialIcons}>
                  <a
                    href="https://www.youtube.com/@bxiworld"
                    target="_blank"
                    alt="wtsp"
                    style={{
                      color: 'inherit',
                      marginTop: '3px',
                    }} rel="noreferrer"
                  >
                    <img src={youtubeicon} alt="youtubeicon" width={20} height={20} style={{ height: '20px', width: '20px' }} />
                  </a>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: {
                  xl: 'flex-end',
                  lg: 'flex-end',
                  md: 'flex-end',
                  sm: 'center',
                  xs: 'center',
                },
                width: {
                  xl: '80%',
                  lg: '80%',
                  md: '80%',
                  sm: '100%',
                  xs: '100%',
                },
              }}
            >
              <Typography
                sx={{
                  ...textDesign,
                  textAlign: {
                    xl: 'right',
                    lg: 'right',
                    md: 'right',
                    sm: 'center',
                    xs: 'center',
                  },
                  fontSize: {
                    xl: '14px',
                    lg: '14px',
                    md: '14px',
                    sm: '12px',
                    xs: '12px',
                  },
                  mt: 1.3,
                }}
              >
                {copyrightText}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Box>
    </>
  );
};

export default Footer;
const FooterText = {
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: { xl: '18px', lg: '18px', md: '18px', sm: '16px', xs: '16px' },
  lineHeight: '35px',
  textAlign: {
    xl: 'left',
    lg: 'left',
    md: 'center',
    sm: 'center',
    xs: 'center',
  },
  color: 'rgba(18, 18, 18, 1)',
};
const socialIcons = {
  width: '36px',
  height: '36px',
  borderRadius: '50%',
  color: '#156DB6', // Original color
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'transform 0.3s ease', // Smooth transition for scaling
  '&:hover': {
    transform: 'scale(1.2)', // Scale up the icon on hover
  },
};
const textDesign = {
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: { xl: '14px', lg: '14px', md: '13px', sm: '13px', xs: '13px' },
  lineHeight: '18px',
  color: 'rgba(0, 0, 0, 1)',
  cursor: 'pointer',
};


